module.exports = __webpack_public_path__ + "img/CarpalTunnel-02.2a27cbc5.svg";